import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Alert
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";
import isEmpty from "lodash.isempty";
import CountryStateCity from "../../../components/countryStateCity/CountryStateCity";
import {
  get_review_details_for_admin,
  update_review_by_admin
} from "../../../redux/actions/reviewActions";
import StarRatingComponent from "react-star-rating-component";
import loader from "../../../style/loader/loader.scss";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
let isLoading = false;
const history = createBrowserHistory();
class EditOfferReview extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    const editLink = props.match.params.reviewID && `editOfferReview/${props.match.params.reviewID}`
    super(props);
    this.state = {
      alertMessage: "",
      msgType: "",
      show: false,
      review: "",
      rating: 0,
      status: "",
      reviewError: "",
      ratingError: "",
      reviewID: "",
      hideForm: false,
      dealID: "",
      path: ["Home", "Review List", "Edit Review"],
      links: ["home",'offerReviews',editLink],
    };
    this.validate = this.validate.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.onStarClick = this.onStarClick.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
  }

  handleChange(e) {
    e.preventDefault();
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    this.setState({ [e.target.name]: e.target.value });
    this.setState({ disabled: false });
  }

  handleEdit = () => {
    this.setState({ hideForm: false });
  };

  onStarClick(nextValue, prevValue, name) {
    this.setState({ rating: nextValue });
  }

  validate = () => {
    let isError = false;
    const errors = {};
    if (this.state.review.length === 0) {
      isError = true;
      this.setState({ reviewError: "red" });
    }
    if (this.state.rating.length === 0) {
      isError = true;
      this.setState({ ratingError: "red" });
    }
    return isError;
  };

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  handleSubmit(e) {
    e.preventDefault();
    const err = this.validate();
    if (!err) {
      if (this.state.reviewID !== "") {
        const updateData = {
          reviewID: this.state.reviewID,
          review: this.state.review,
          dealID: this.state.dealID,
          rating: this.state.rating,
          status: this.state.status
        };

        this.props.update_review_by_admin(updateData);
      }
    }
  }

  componentWillMount() {
    let reviewIdParams = this.props.match.params.reviewID
      ? this.props.match.params.reviewID
      : "";
    this.setState({ reviewID: reviewIdParams });
    this.props.get_review_details_for_admin(reviewIdParams);
  }
  componentWillReceiveProps(nextProps) {
    if (
      this.props.reviewDetailsForAdmin !== nextProps.reviewDetailsForAdmin &&
      !isEmpty(nextProps.reviewDetailsForAdmin)
    ) {
      this.setState({
        status: nextProps.reviewDetailsForAdmin.status,
        reviewID: nextProps.reviewDetailsForAdmin.reviewID,
        rating: nextProps.reviewDetailsForAdmin.rating,
        review: nextProps.reviewDetailsForAdmin.review
      });
    }
    if (this.props.message !== nextProps.message) {
      this.handleShow();
      this.setState({ alertMessage: nextProps.message });
      window.scrollTo(0, 0);
    }
    if (this.props.alertType !== nextProps.alertType) {
      this.handleShow();
      this.setState({ msgType: nextProps.alertType });
      window.scrollTo(0, 0);
    }
    if (this.props.error !== nextProps.error && nextProps.error.length > 0) {
      this.props.clearAlert();
      this.handleShow();
      this.props.renderAlert("warning", nextProps.error);
      this.setState({ msgType: "warning" });
      window.scrollTo(0, 0);
    }
    if (
      this.props.updatedReviewResponseByAdmin !==
      nextProps.updatedReviewResponseByAdmin
    ) {
      this.props.clearAlert();
      this.handleShow();
      this.props.renderAlert(
        "success",
        nextProps.updatedReviewResponseByAdmin.message
      );
      this.setState({ msgType: "success" });
      window.scrollTo(0, 0);
      this.props.get_review_details_for_admin(this.state.reviewID);
    }
  }

  render() {
    return (
      <div className="editReview">
        {this.props.receivingReviewDetails ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}
        <div className="row">
          {this.state.show &&
            this.state.alertMessage !== "" && (
              <div className="col-lg-12">
                <Alert
                  bsStyle={this.state.msgType}
                  onDismiss={this.handleDismiss}
                >
                  <strong>{this.state.msgType}:</strong>{" "}
                  {this.state.alertMessage}
                </Alert>
              </div>
            )}
          <div className="col-xs-12">
            <BreadcrumbComponent path={this.state.path} links={this.state.links} context={this.context}/>
          </div>
        </div>
        <div className="panel">
          <header className="panel-heading">Edit Review</header>
          <div className="panel-body">
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <Row>
                <Col md={8} xs={12} mdOffset={2}>
                  <form onSubmit={this.handleSubmit}>
                    <Row>
                      <Col md={12} xs={12}>
                        <FormGroup controlId="formReview">
                          <ControlLabel>Review</ControlLabel>
                          <FormControl
                            value={this.state.review}
                            componentClass="textarea"
                            onChange={this.handleChange}
                            name="review"
                            placeholder="Give Your Review"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={12} xs={12}>
                        <FormGroup controlId="formControlsSelect">
                          <ControlLabel>Status</ControlLabel>
                          <FormControl
                            componentClass="select"
                            placeholder="Status"
                            name="status"
                            value={this.state.status}
                            onChange={this.handleChange}
                          >
                            <option value="">Select Status</option>
                            <option value="public">Public</option>
                            <option value="private">Private</option>
                            <option value="notapproved">Not Approved</option>
                          </FormControl>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={12} xs={12}>
                        <div>
                          <div style={{ fontWeight: "bold" }}>Rating</div>
                          <StarRatingComponent
                            name="rate1"
                            starCount={5}
                            value={this.state.rating}
                            onStarClick={this.onStarClick.bind(this)}
                          />
                        </div>
                      </Col>
                    </Row>
                    <Row className="BtnRow">
                      <Col md={12} xs={12}>
                        <Button
                          bsStyle="info"
                          type="submit"
                          id="submitButton"
                          disabled={this.props.updatingReviewByAdmin}
                        >
                          Submit
                        </Button>
                        <Button
                          bsStyle="default"
                          onClick={() => this.context.router.history.push(`/offerReviews`)}
                        >
                          Cancel
                        </Button>
                      </Col>
                    </Row>
                  </form>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

EditOfferReview.propTypes = {
  get_review_details_for_admin: PropTypes.func.isRequired,
  update_review_by_admin: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  reviewDetailsForAdmin: state.reviewReducer.reviewDetailsForAdmin,
  error: state.reviewReducer.error,
  message: state.alertsReducer.message,
  alertType: state.alertsReducer.alertType,
  updatedReviewResponseByAdmin:
    state.reviewReducer.updatedReviewResponseByAdmin,
  receivingReviewDetails: state.reviewReducer.receivingReviewDetails,
  updatingReviewByAdmin: state.reviewReducer.updatingReviewByAdmin
});
export default compose(
  withRouter, // IMPORTANT: witRouter is "needed here" to avoid blocking routing:
  connect(mapStateToProps, {
    get_review_details_for_admin,
    update_review_by_admin,
    clearAlert,
    renderAlert
  })
)(EditOfferReview);



// WEBPACK FOOTER //
// ./src/app/views/admin/offerReview/EditOfferReview.js